import React from 'react';
import { Mail, MapPin, Phone, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="relative overflow-hidden">
      {/* Main footer */}
      <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-12 md:py-16">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-72 h-72 md:w-96 md:h-96 bg-green-500 rounded-full blur-3xl opacity-10"></div>
        <div className="absolute bottom-0 right-0 w-72 h-72 md:w-96 md:h-96 bg-blue-500 rounded-full blur-3xl opacity-10"></div>

        <div className="container mx-auto px-4 relative z-10">
          {/* ✅ Mobile: عمود واحد | Desktop: 4 أعمدة */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12 text-right" dir="rtl">
            {/* Company info */}
            <div className="md:col-span-2">
              <div className="flex items-center gap-3 justify-end mb-5 md:mb-6">
                <h3 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-green-400 to-green-500 bg-clip-text text-transparent">
                  الوسيط الناقل
                </h3>
                <div className="w-11 h-11 md:w-12 md:h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-lg md:text-xl">WN</span>
                </div>
              </div>

              <p className="text-gray-300 leading-relaxed mb-6 text-base md:text-lg">
                تأسس الناقل الوسيط للنقل في عام 2017م ودشنت نشاطها بتقديم خدمات النقل الدولي والداخلي بأعلى مستويات الجودة.
              </p>

              {/* ✅ فاصل لطيف على الموبايل */}
              <div className="h-px bg-gray-700/60 md:hidden"></div>
            </div>

            {/* Quick links */}
            <div className="md:mt-0">
              <h3 className="text-lg md:text-xl font-bold mb-5 md:mb-6 text-green-400">روابط سريعة</h3>
              <ul className="space-y-3">
                {[
                  { href: '#about', label: 'عن الشركة' },
                  { href: '#services', label: 'خدماتنا' },
                  { href: '#partners', label: 'شركاؤنا' },
                  { href: '#contact', label: 'اتصل بنا' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-gray-300 hover:text-green-400 transition-all duration-300 flex items-center gap-2 justify-end group"
                    >
                      <span className="group-hover:translate-x-2 transition-transform duration-300">
                        {item.label}
                      </span>
                      <span className="w-0 h-0.5 bg-green-400 group-hover:w-6 transition-all duration-300"></span>
                    </a>
                  </li>
                ))}
              </ul>

              <div className="h-px bg-gray-700/60 mt-8 md:hidden"></div>
            </div>

            {/* Contact info */}
            <div>
              <h3 className="text-lg md:text-xl font-bold mb-5 md:mb-6 text-green-400">تواصل معنا</h3>

              <div className="space-y-4">
                {/* ✅ خلي النص يلف على الموبايل */}
                <div className="flex items-start gap-3 justify-end group">
                  <span className="text-gray-300 group-hover:text-white transition-colors text-sm md:text-base break-words">
                    اليمن - عدن جولة السفينة برج القاضي
                  </span>
                  <div className="shrink-0 w-10 h-10 rounded-lg bg-gray-700 group-hover:bg-gradient-to-r group-hover:from-green-400 group-hover:to-green-600 flex items-center justify-center transition-all duration-300">
                    <MapPin className="w-5 h-5 text-green-400 group-hover:text-white" />
                  </div>
                </div>

                <div className="flex items-center gap-3 justify-end group">
                  <span className="text-gray-300 group-hover:text-white transition-colors text-sm md:text-base break-words">
                    00967780562000
                  </span>
                  <div className="shrink-0 w-10 h-10 rounded-lg bg-gray-700 group-hover:bg-gradient-to-r group-hover:from-green-400 group-hover:to-green-600 flex items-center justify-center transition-all duration-300">
                    <Phone className="w-5 h-5 text-green-400 group-hover:text-white" />
                  </div>
                </div>

                <div className="flex items-center gap-3 justify-end group">
                  {/* ✅ أهم سطر: الإيميل لا يطلع خارج الشاشة */}
                  <span className="text-gray-300 group-hover:text-white transition-colors text-sm md:text-base break-all">
                    info@alwasitalnaqilye.com
                  </span>
                  <div className="shrink-0 w-10 h-10 rounded-lg bg-gray-700 group-hover:bg-gradient-to-r group-hover:from-green-400 group-hover:to-green-600 flex items-center justify-center transition-all duration-300">
                    <Mail className="w-5 h-5 text-green-400 group-hover:text-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-gray-950 py-5 md:py-6">
        <div className="container mx-auto px-4">
          {/* ✅ على الموبايل يصير عمودي ووسط، على الديسكتوب صف */}
          <div
            className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 text-gray-400 text-sm md:text-base text-center md:text-right"
            dir="rtl"
          >
            <p className="leading-relaxed">
              © {new Date().getFullYear()} الوسيط الناقل. جميع الحقوق محفوظة
            </p>

            <p className="flex items-center justify-center md:justify-end gap-2">
              تم التطوير بواسطة
              <Heart className="w-4 h-4 text-red-500 animate-pulse" fill="currentColor" />
              <a
                href="https://adenrobot.com"   // ← حط رابط عدن روبوت هنا
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-green-500 hover:text-green-600 transition-colors underline"
              >
                عدن روبوت
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
